import React from 'react';
import * as ToggleGroup from '@radix-ui/react-toggle-group';
import InputRadioLabel from './InputRadioLabel';

const InputRadioLabelGroup = ({ items, value, setValue }) => (
  <ToggleGroup.Root
    className='gap-[7px] flex flex-wrap'
    type='single'
    defaultValue={items?.length >= 1 ? items[items.length - 1] : null}
    aria-label='Year filter'
    data-component-name='InputRadioLabelGroup'
    value={value}
    onValueChange={(value) => {
      if (value) {
        setValue(value);
      }
    }}
  >
    {items &&
      items.length >= 1 &&
      items.map((item, i) => {
        return (
          <ToggleGroup.Item
            className='group'
            value={item}
            aria-label='Left aligned'
            key={`${i}`}
          >
            <InputRadioLabel>{item}</InputRadioLabel>
          </ToggleGroup.Item>
        );
      })}
  </ToggleGroup.Root>
);

export default InputRadioLabelGroup;
